import styled from "styled-components";
import { COLORS } from "../../../../styles/constants.style";

export const MdmActivitySearchResultWrapper = styled.div`
  margin: 19px 0px 39px;

  .result-header {
    display: flex;
    align-items: center;
    background-color: ${COLORS.primary_light_blue2};
    padding: 6px 16px;

    .header-text {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }

    .selected-count {
      color: ${COLORS.cirrus_white};
      background-color: ${COLORS.cirrus_black7};
      padding: 2px 9px 4px 9px;
      border-radius: 8px;
      margin-left: 8px;
      height: 28px;
    }
  }

  .MuiTableCell-root .mui-text-field {
    height: 48px;
  }

  .units-cell {
    min-width: 140px;
  }

  .activity-column {
    width: 250px;
    min-width: 250px;
  }
`;
